export default __webpack_public_path__ + "static/media/Call.729c32a0.svg";